/*
 * @Author: lbh
 * @Date: 2021-11-13 14:32:21
 * @LastEditors: lbh
 * @LastEditTime: 2025-07-02 17:45:27
 * @Description: 美團日誌
 */
import Logan from "logan-web";
import MobileDetect from "mobile-detect";
import util from "./util";
import K from "./loca_key";
import { addLog } from "@/js/api/system/api";
let loganWeb = "https://logan.ricepon.com/logan-web";
import { lodash } from "./lodash";

let sqlLog = {
  types: [
    "操作日志",
    "加入購物車",
    "移除購物車",
    "清空購物車",
    "跳轉頁面",
    "請求數據",
    "響應數據",
    "食品數量出錯",
  ],
  add(keywords, operationSteps, param) {
    addLog({
      keywords,
      operationSteps,
      param,
      optTime: Date.now(),
    });
  },
};

let log = {
  types: {
    default: 0, // 操作日志
    plus: 1, // 加购
    minus: 2, // 减购
    go: 4, // 跳转页面
    clear: 3, // 清空购物车
    request: 5, // 请求
    response: 6, // 响应
    error: 7, // 食品数量出错
  },

  /**
   * * 添加記錄
   * @param {*} content  內容
   * @param {*} type  類型
   */
  add(deviceId, content, type) {
    content = lodash.clone(content);
    let user_id = util.userInfoFun.get().id;
    // let random = util.getToken();
    let logContent = {};
    // * 沒有用戶id, 就不要咯
    if (user_id) logContent.uid = user_id;
    if (type == log.types.request) {
      // * 請求數據 處理一下
      let { url, method, data, params } = content;
      url =
        url.split(location.origin).length > 1
          ? url.split(location.origin)[1]
          : url;
      logContent.u = url;
      logContent.r = method == "get" ? params : data;
    } else if (type == log.types.response) {
      // * 將 響應類型處理一下
      let { config, data } = content;
      let url = config.url;
      url =
        url.split(location.origin).length > 1
          ? url.split(location.origin)[1]
          : url;
      logContent.u = url;
      // * 如果是 food/shopMenuNew
      if (url.includes("food/shopMenuNew")) {
        logContent.r = filter.findMenuNew.filterFindMenuNew(data);
      } else if (url.includes("food/findFoodCombo")) {
        logContent.r = filter.findFoodCombo.filterFindFoodCombo(data.data);
      } else {
        logContent.r = data;
      }
    } else logContent = content;
    Logan.log(JSON.stringify(logContent), type);

    let restaurant_id = localStorage.getItem(K.restaurant_id);
    let config = ["26", "367"];
    let types = [0, 1, 2, 3, 4];
    if (config.indexOf(restaurant_id) > -1 && types.indexOf(type) > -1) {
      sqlLog.add(deviceId, sqlLog.types[type], JSON.stringify(logContent));
    }
  },
  /**
   * 推送記錄
   * @param {*} deviceId  唯一標識   餐廳id_餐桌號_2021-11-13
   */
  push(deviceId) {
    const md = new MobileDetect(window.navigator.userAgent);
    // * 默認會重試3次
    Logan.report({
      reportUrl: `${loganWeb}/logan/web/upload.json`, // 上傳地址
      deviceId, // 唯一標識
      webSource: md.userAgent(), // 瀏覽器
      environment: md.ua, // 瀏覽器全部信息
      incrementalReport: true, // 上傳日誌後, 就刪除記錄
      fromDayString: util.addDate(util.getDate(), 0), // 今天
      toDayString: util.addDate(util.getDate(), 1), // 明天
    });
  },
  /**
   * * 記錄日誌
   * @param {*} content  內容
   */
  log(content, type) {
    if (location.origin.includes("https://m.ricepon")) {
      let restaurant_id = localStorage.getItem(K.restaurant_id);
      let user_id = util.userInfoFun.get().id;
      let random = util.getToken();
      let date = util.time.format(6);
      let re_type = localStorage.getItem(K.re_type);
      let key = "";
      // 表示掃碼點餐 || 固定碼
      if (re_type == 2 || re_type == 4) {
        let tableName = localStorage.getItem(K.tableName()) || "";
        key = `shop_${date}_${re_type}_${restaurant_id}_${tableName}_${random}_${user_id}`;
      }
      // 外送自取
      else if (re_type == 1 || re_type == 7) {
        key = `shop_${date}_${re_type}_${restaurant_id}_${random}_${user_id}`;
      }
      // 其他
      else {
        key = `shop_${date}_${random}_${user_id}`;
      }
      this.add(key, content, type);
      setTimeout(() => {
        this.push(key);
      }, 30);
    }
  },
};

export default log;

// * 過濾器
const filter = {
  // ? 處理 餐牌接口數據
  findMenuNew: {
    // * 主數據
    data: [
      "food",
      "restaurant",
      "rounding",
      "roundingDecimal",
      "shoppingCartConfig",
      "zeroAmountDisplay",
    ],
    // * 餐廳細膩係
    restaurant: ["brandId", "id", "openStatus"],
    // * 食品組
    foodGroup: ["foodName", "foods", "id"],
    // * 食品
    foods: ["foodName", "id", "price"],
    filterFindMenuNew(data) {
      let result_ = filter.getFilterObject(this.data, data);
      let food = [];
      result_.food.forEach((item) => {
        let _item = filter.getFilterObject(this.foodGroup, item);
        _item.foods.forEach((food, index) => {
          _item.foods[index] = filter.getFilterObject(this.foods, food);
        });
        food.push(_item);
      });
      let restaurant = filter.getFilterObject(
        this.restaurant,
        result_.restaurant
      );
      result_.food = food;
      result_.restaurant = restaurant;
      return result_;
    },
  },

  // ? 處理套餐係項
  findFoodCombo: {
    // * 第一級
    topOne: [
      "food_name",
      "price",
      "id",
      "invisible",
      "multiple_select",
      "show_type",
      "top",
      "lunchboxPrice",
      "startQuantity",
      "increaseQuantity",
      "foodType",
      "defmodifier",
      "automod",
      "auto_merge",
    ],
    // * 第二級
    topTwo: ["name", "minqty", "id", "maxqty", "multiple_select", "top"],
    // * 第三級
    topThree: ["name", "id", "maxqty", "minqty", "top", "price"],
    // * 第四級
    topFour: ["name", "id", "top"],
    // * 第五級
    topFive: ["name", "id", "invisible", "price"],
    // * 過濾方法
    filterFindFoodCombo(data) {
      let result = {};
      result = filter.getFilterObject(this.topOne, data);
      if (result.top) {
        let t1 = [];
        result.top.forEach((item) => {
          let _t1 = filter.getFilterObject(this.topTwo, item);
          if (_t1.top) {
            let t2 = [];
            _t1.top.forEach((it2) => {
              let _t2 = filter.getFilterObject(this.topThree, it2);
              if (_t2.top) {
                let t3 = [];
                _t2.top.forEach((it3) => {
                  let _t3 = filter.getFilterObject(this.topFour, it3);
                  if (_t3.top) {
                    let t4 = [];
                    _t3.top.forEach((it4) => {
                      let _t4 = filter.getFilterObject(this.topFive, it4);
                      t4.push(_t4);
                    });
                    _t3.top = t4;
                  }
                  t3.push(_t3);
                });
                _t2.top = t3;
              }
              t2.push(_t2);
            });
            _t1.top = t2;
          }
          t1.push(_t1);
        });
        result.top = t1;
      }
      return result;
    },
  },
  /**
   * ? 根据字段数组过滤对象，只保留指定字段
   * @param {Array} filter 需要保留的字段名称数组
   * @param {Object} object 需要被过滤的对象
   * @returns {Object} 过滤后的新对象
   */
  getFilterObject(filter, object) {
    if (!Array.isArray(filter) || !object || typeof object !== "object") {
      return {};
    }
    const result = {};
    filter.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        result[key] = object[key];
      }
    });
    return result;
  },
};
